// extracted by mini-css-extract-plugin
export default {"page":"fU","heading":"gU","subheading":"hU","flavorbox":"iU","inner":"jU","image":"kU","label":"lU","flavorselect":"mU","arrow":"nU","flavorswrap":"oU","flavorsheader":"pU","flavorsnav":"qU","flavorsinner":"rU","cancelbtn":"sU","flavorsbottom":"tU","retakebtn":"uU","continueBtn":"vU","drawerinner":"wU","videowrap":"xU","flavorsbottomnav":"yU"};
    if(module.hot) {
      // 1715091682824
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  